export default __webpack_public_path__ + "static/media/chevron.up.f47ce163.svg";